import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { kFormatter } from '@root/utilities/common';
import capitalize from 'lodash/capitalize';

export const VulnerabilityCounts = ({ vulnerabilities, customClassName, addUnknown = false, severities }) => {
  // Define severity levels and their colors
  const severityConfig = [
    { type: 'critical', color: '#FF6A7C', value: vulnerabilities.critical ?? 0 },
    { type: 'high', color: '#FFD19F', value: vulnerabilities.high ?? 0 },
    { type: 'medium', color: '#FFC444', value: vulnerabilities.medium ?? 0 },
    { type: 'low', color: '#8AECC5', value: vulnerabilities.low ?? 0 },
    { type: 'info', color: '#5AB3FF', value: vulnerabilities.info ?? 0 },
  ];

  // Only add 'unknown' if it exists and is not undefined/null
  if (
    addUnknown &&
    typeof vulnerabilities.unknown !== 'undefined' &&
    vulnerabilities.unknown !== null &&
    vulnerabilities.unknown !== 0
  ) {
    severityConfig.push({ type: 'unknown', color: '#CBD5E0', value: vulnerabilities.unknown ?? 0 });
  }

  // `severities` narrows the chips (and the tooltip) to the levels the caller's data carries, e.g. a
  // critical / high only count, so the levels it leaves out don't show as zeros.
  const levels = severities ? severityConfig.filter(level => severities.includes(level.type)) : severityConfig;

  // // Format number to max 3 chars
  // const formatValue = (value) => {
  //   if (value >= 1000) {
  //     return '1K+';
  //   }
  //   return value.toString();
  // };

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      width: '100%',
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      border: '1px solid var(--border-color-light)',
      borderRadius: '0px 2px 2px 0px',
      minWidth: '45px', // Ensure consistent width
    },
    bar: {
      width: '6px',
      height: '24px',
      borderRadius: '2px 0px 0px 2px',
      marginRight: '6px',
      flexShrink: 0, // Prevent bar from shrinking
    },
    count: {
      fontSize: '14px',
      fontWeight: '500',
      paddingRight: '6px',
      textAlign: 'center',
      flex: 1,
      minWidth: '30px', // Ensure consistent width for numbers
    },
  };

  return (
    <Tooltip
      title={
        severities
          ? levels.map(level => `${level.value} ${capitalize(level.type)}`).join(', ')
          : `${vulnerabilities.critical} Critical, ${vulnerabilities.high} High, ${vulnerabilities.medium} Medium, ${
              vulnerabilities.low
            } Low, ${vulnerabilities.info ?? 0} Info, ${
              addUnknown && vulnerabilities.unknown !== 0 ? `${vulnerabilities.unknown} Unknown` : ''
            }`
      }
      isIcon={true}>
      <div style={styles.container}>
        {levels.map(level => (
          <div key={level.type} style={styles.item}>
            <div style={{ ...styles.bar, backgroundColor: level.color }}></div>
            <span style={styles.count} className={customClassName}>
              {kFormatter(level.value)}
            </span>
          </div>
        ))}
      </div>
    </Tooltip>
  );
};
